var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('nav-bar',{staticClass:"my-2"}),_c('router-view',{class:_vm.$vuetify.breakpoint.mobile ? 'mt-12' : ''}),_c('Footer',{staticClass:"my-0"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }